import { render, staticRenderFns } from "./CopilotoConductores.vue?vue&type=template&id=589d3bd5&scoped=true&"
import script from "./CopilotoConductores.vue?vue&type=script&lang=ts&"
export * from "./CopilotoConductores.vue?vue&type=script&lang=ts&"
import style0 from "./CopilotoConductores.vue?vue&type=style&index=0&id=589d3bd5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589d3bd5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('589d3bd5', component.options)
    } else {
      api.reload('589d3bd5', component.options)
    }
    module.hot.accept("./CopilotoConductores.vue?vue&type=template&id=589d3bd5&scoped=true&", function () {
      api.rerender('589d3bd5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/CopilotoVirtual/Conductores/CopilotoConductores.vue"
export default component.exports